module.exports = __webpack_public_path__ + "media/04.fd9b3842.mp4";